import { render, staticRenderFns } from "./ChatsPage.vue?vue&type=template&id=030739a2&lang=pug&"
import script from "./ChatsPage.ts?vue&type=script&lang=js&"
export * from "./ChatsPage.ts?vue&type=script&lang=js&"
import style0 from "./ChatsPage.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports